module.exports = __webpack_public_path__ + "img/ic-email-sent@3x.f45edfe8.png";